import type { CSSProperties, ReactNode } from 'react'
import css from 'classnames'

interface NotificationIndicatorProps {
  visible: boolean
  children?: ReactNode
  className?: string
  color?: CSSProperties['backgroundColor']
  label?: string
  variant?: 'dot' | 'count'
}

export const NotificationIndicator = ({
  visible,
  children,
  className,
  color = '#DC2626',
  label,
  variant = 'dot',
}: NotificationIndicatorProps) => {
  if (!visible) {
    return null
  }

  if (variant === 'dot') {
    return (
      <span
        className={css(
          'block h-[6px] w-[6px] min-h-[6px] min-w-[6px] max-h-[6px] max-w-[6px] flex-none rounded-full',
          className,
        )}
        style={{
          backgroundColor: color,
          borderRadius: '50%',
          flexShrink: 0,
          height: '6px',
          maxHeight: '6px',
          maxWidth: '6px',
          minHeight: '6px',
          minWidth: '6px',
          width: '6px',
        }}
        title={label}
        aria-label={label}
      />
    )
  }

  return (
    <span
      className={css(
        'inline-flex shrink-0 items-center justify-center rounded-full text-[10px] font-semibold leading-none text-white',
        'h-5 w-5',
        className,
      )}
      style={{
        backgroundColor: color,
        height: '20px',
        maxHeight: '20px',
        maxWidth: '20px',
        minHeight: '20px',
        minWidth: '20px',
        width: '20px',
      }}
      title={label}
      aria-label={label}
    >
      {children}
    </span>
  )
}
